var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTotalCash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4567",
    "data-name": "Group 4567",
    transform: "translate(-16 -184)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_266",
    "data-name": "Ellipse 266",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(16 184)",
    fill: "#2665a4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "uuid-f7006d7b-abcb-4ee8-a21c-d030d0f4a18f",
    transform: "translate(22.334 190.334)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3049",
    "data-name": "Path 3049",
    d: "M141.842,148.5a6.654,6.654,0,0,1-1.692-.437,6.078,6.078,0,0,1-3.864-5.091,6.242,6.242,0,0,1,12.369-1.677c.018.111.039.222.058.333v1.284c-.009.043-.021.085-.027.128a6.2,6.2,0,0,1-3.853,5.018,6.536,6.536,0,0,1-1.708.442h-1.284Zm1.195-9.537c0-.164,0-.327,0-.49,0-.115-.044-.156-.157-.154-.258,0-.516.008-.773,0-.146-.005-.183.056-.18.19.008.264-.009.529.006.792a.33.33,0,0,1-.216.361,1.634,1.634,0,0,0-.827,2,1.676,1.676,0,0,0,1.6,1.168.568.568,0,0,1,.571.54.579.579,0,0,1-1.139.189.16.16,0,0,0-.184-.137c-.258.006-.515.005-.773,0-.119,0-.167.025-.15.162a1.636,1.636,0,0,0,.939,1.324.272.272,0,0,1,.178.29c-.011.289,0,.578,0,.868,0,.122.042.169.165.166.258-.006.516-.007.773,0,.135,0,.175-.051.172-.179-.007-.251.012-.5-.006-.754a.391.391,0,0,1,.255-.434,1.64,1.64,0,0,0,.838-1.8,1.676,1.676,0,0,0-1.433-1.312,2.612,2.612,0,0,1-.373-.051.568.568,0,0,1-.415-.6.578.578,0,0,1,.481-.531.559.559,0,0,1,.639.38.222.222,0,0,0,.267.184c.239-.012.478-.007.717,0,.115,0,.152-.032.139-.154a1.434,1.434,0,0,0-.724-1.194.657.657,0,0,1-.388-.778.318.318,0,0,0,0-.038Z",
    transform: "translate(-129.382 -129.165)",
    fill: "#3bb0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3050",
    "data-name": "Path 3050",
    d: "M7.174,0c.473.06.947.11,1.414.215A6.891,6.891,0,0,1,11.473,1.5a2.97,2.97,0,0,1,.857,1.04,2.083,2.083,0,0,1-.339,2.372,4.868,4.868,0,0,1-2.16,1.4,9.836,9.836,0,0,1-3.158.572,10.7,10.7,0,0,1-3.789-.527,6.1,6.1,0,0,1-1.723-.88A2.866,2.866,0,0,1,0,3.813V3.1A2.9,2.9,0,0,1,.939,1.627,6.793,6.793,0,0,1,3.841.255,13.681,13.681,0,0,1,5.438,0H7.174Z",
    transform: "translate(0.001)",
    fill: "#3bb0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3051",
    "data-name": "Path 3051",
    d: "M-.009,117.75A8.31,8.31,0,0,0,4.721,119.7a11.954,11.954,0,0,0,3.007.009c.041-.005.095-.025.118.026s-.023.082-.052.112a7.217,7.217,0,0,0-1.428,2.138.171.171,0,0,1-.174.116,8.995,8.995,0,0,1-4.761-1.214,3.558,3.558,0,0,1-1.025-.936,2.563,2.563,0,0,1-.416-.922V117.75Z",
    transform: "translate(0.01 -111.822)",
    fill: "#3bb0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3052",
    "data-name": "Path 3052",
    d: "M0,252.74A8.38,8.38,0,0,0,4.829,254.7a7.25,7.25,0,0,0,.939.07.209.209,0,0,1,.238.184,6.831,6.831,0,0,0,.823,1.957c.08.13.055.176-.1.18a9.869,9.869,0,0,1-4.853-.95,4.661,4.661,0,0,1-.911-.6A2.743,2.743,0,0,1,0,254.024V252.74Z",
    transform: "translate(0.001 -240.016)",
    fill: "#3bb0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3053",
    "data-name": "Path 3053",
    d: "M0,185.25a8.369,8.369,0,0,0,4.847,1.958,7.246,7.246,0,0,0,.939.071c.153,0,.179.064.15.2a6.269,6.269,0,0,0-.154,1.908c.01.109.009.2-.151.186a8.84,8.84,0,0,1-4.1-1.139,3.483,3.483,0,0,1-1.256-1.2,2.724,2.724,0,0,1-.273-.7V185.25Z",
    transform: "translate(0.001 -175.924)",
    fill: "#3bb0ff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTotalCash);
export default __webpack_public_path__ + "static/media/icon-total-cash.f7e6d19ab6699885cb6479ceb06ac97f.svg";
export { ForwardRef as ReactComponent };